import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default, { useState } from 'react';
import cx from 'classnames';
import './ThemeContext-e1f446be.js';
import './SearchIcon-835318c0.js';
import './index-56745294.js';
import './chevronLeftSVG.js';
import './chevronRightSVG.js';
import './chevronRightThinSVG.js';
import './chevronUpThinSVG.js';
import './IconQuestionFilled-146e7ca3.js';
import './icon-tick-filled-3149e72f.js';
import './minusCircle.js';
import './plusCircle.js';
import './Photos-5eb9c552.js';
import { F as FeedbackTooltip } from './FeedbackTooltip-fe34aaac.js';
import '@tippy.js/react';
import './theme.js';
import './helpers-1066b771.js';
import './tooltip.js';
import './tooltipAnchor.js';

const Textarea = props => {
  const [wrapperRef, setWrapperRef] = useState(null);
  const {
    className,
    id,
    label,
    labelProps,
    textareaProps,
    intent,
    feedbackTooltip = {}
  } = props;
  if (!id) {
    console.warn(`Textarea element with the label "${label}" needs an ID attribute to associate label with the input`);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cx('mw-input', className)
  }, label && /*#__PURE__*/React__default.createElement("label", _extends({
    htmlFor: id
  }, labelProps), label), /*#__PURE__*/React__default.createElement(FeedbackTooltip, {
    intent: intent,
    appendTo: wrapperRef,
    content: feedbackTooltip.content,
    placement: feedbackTooltip.placement,
    placementFlipped: feedbackTooltip.placementFlipped,
    fillWidth: feedbackTooltip.fillWidth
  }, /*#__PURE__*/React__default.createElement("textarea", _extends({
    ref: setWrapperRef,
    className: "mw-textarea",
    placeholder: "The quick brown fox jumps over the lazy dog"
  }, textareaProps))));
};

export default Textarea;
